module.exports = __webpack_public_path__ + "img/cleaner_arrival-icon.97b09b0c.svg";